import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';
import { LogCoreService } from './log-core.service';
import { ElementService } from '../element/element.service';
import { ModuleService } from '../module/module.service';
import { SubmoduleService } from '../submodule/submodule.service';
import { Observable } from 'rxjs';
import { ElementCommentSummary, ElementChange, ElementComment, ElementLogs } from './logs.interface';
import { ProjectElement } from '../element/project-element.interface';
import { UserService } from '../user/user.service';
import { ConstantsService } from '../../utilities/constants/constants.service';
import { TranslateService } from '../../utilities/translate/translate.service';

@Injectable({
  providedIn: 'root'
})
export class LogService extends LogCoreService {

  constructor(
    protected apiService: ApiService,
    protected constantsService: ConstantsService,
    protected elementService: ElementService,
    protected moduleService: ModuleService,
    protected submoduleService: SubmoduleService,
    protected userService: UserService,
    protected translateService: TranslateService
  ) {
    super(apiService, constantsService, elementService, moduleService, submoduleService, userService, translateService);
  }

  /**
   * Get comment counts for all elements.
   *
   * @todo Interfaces.
   *
   * @returns Observable with comment counts for all elements.
   */
  public getElementCommentCount(): Observable<ElementCommentSummary[]> {
    return new Observable(observer => {
      this.apiService.getElementCommentCount().subscribe(counts => {
        observer.next(counts.summary);
        observer.complete();
      });
    });
  }

  /**
   * Get element changes.
   *
   * @param element The element to get the changes for.
   * @returns Observable with changes.
   */
  public getElementChanges(element: ProjectElement): Observable<ElementChange[]> {
    return new Observable(observer => {
      this.apiService.getElementLogs(element).subscribe(logs => {
        logs = this._filterInactive(logs);
        logs.changes = this._enrichChanges(logs.changes);
        observer.next(logs.changes);
        observer.complete();
      });
    });
  }

  /**
   * Get element comments.
   *
   * @param element The element to get the comments for.
   * @returns Observable with comments.
   */
  public getElementComments(element: ProjectElement): Observable<ElementComment[]> {
    return new Observable(observer => {
      this.apiService.getElementLogs(element).subscribe(logs => {
        logs = this._filterInactive(logs);
        logs.comments = this._enrichComments(logs.comments);
        observer.next(logs.comments);
        observer.complete();
      });
    });
  }

  /**
   * Get logs. Changes and comments.
   *
   * @todo Param for capping results.
   *
   * @returns Observable with logs for the project.
   */
  public getLogs(): Observable<ElementLogs> {
    return new Observable(observer => {
      this.apiService.getProjectLogs().subscribe(logs => {
        logs = this._filterInactive(logs);
        logs.changes = this._enrichChanges(logs.changes);
        logs.comments = this._enrichComments(logs.comments);
        observer.next(logs);
        observer.complete();
      });
    });
  }
}
